import {
  LkTopic as Data,
  LkTopicCollection as Collection,
} from '@/typings/api/Topic'
import {
  BaseApiParams,
  BaseApiResponse,
  BaseApiResponseCollection,
} from '@/typings/common'

import { BaseLkPublicApi } from '@/api/BaseApi'
import { AxiosRequestConfig } from 'axios'


type BRC = BaseApiResponseCollection<never> & {
  topics: Collection[];
}

export class LkPublicTopicsApi extends BaseLkPublicApi<
  Data,
  Collection,
  BaseApiParams,
  BaseApiResponse<Data>,
  BRC
  > {
  protected readonly endpoint = 'topics';

  public getAll<P extends BaseApiParams, R extends BRC = BRC>(
    rawParams: P, config?: AxiosRequestConfig,
  ) {
    const path = '/tree'
    const [url, params] = this.getUrl(path, rawParams)
    return this.request<never, R>('GET', url, { params, ...config })
  }
}
